// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3cM7t","author":"Table_author__W8GQc","authorImage":"Table_authorImage__OPdB9","unreadRow":"Table_unreadRow__3mH6f"};